import React from 'react'

import './Overview.css'

const content1 = require('../DashboardMulti/graph1.jpg')

export default () => (
  <div className="container-fluid">
    {/* Row */}
    <div className="row">
      <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
        <div className="panel panel-default card-view pa-0 bg-gradient">
          <div className="panel-wrapper collapse in">
            <div className="panel-body pa-0">
              <div className="sm-data-box">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-xs-6 text-center pl-0 pr-0 data-wrap-left">
                      <span className="txt-light block counter"><span className="counter-anim">200 MH/s</span></span>
                      <span className="weight-500 uppercase-font block font-13 txt-light">Total Hashrate</span>
                    </div>
                    <div className="col-xs-6 text-center  pl-0 pr-0 data-wrap-right">
                      <i className="icon-direction data-right-rep-icon txt-light" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
        <div className="panel panel-default card-view pa-0 bg-gradient1">
          <div className="panel-wrapper collapse in">
            <div className="panel-body pa-0">
              <div className="sm-data-box">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-xs-6 text-center pl-0 pr-0 data-wrap-left">
                      <span className="txt-light block counter"><span className="counter-anim">15.00</span>%</span>
                      <span className="weight-500 uppercase-font block txt-light">PROFIT</span>
                    </div>
                    <div className="col-xs-6 text-center  pl-0 pr-0 data-wrap-right">
                      <i className="icon-graph  data-right-rep-icon txt-light" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
        <div className="panel panel-default card-view pa-0 bg-gradient3">
          <div className="panel-wrapper collapse in">
            <div className="panel-body pa-0">
              <div className="sm-data-box">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-xs-6 text-center pl-0 pr-0 data-wrap-left">
                      <span className="txt-light block counter"><span className="counter-anim">2.5</span>ETH</span>
                      <span className="weight-500 uppercase-font block txt-light">YIELD</span>
                    </div>
                    <div className="col-xs-6 text-center  pl-0 pr-0 data-wrap-right">
                      <i className="icon-layers data-right-rep-icon txt-light" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
        <div className="panel panel-default card-view pa-0 bg-gradient2">
          <div className="panel-wrapper collapse in">
            <div className="panel-body pa-0">
              <div className="sm-data-box">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-xs-6 text-center pl-0 pr-0 data-wrap-left">
                      <span className="txt-light block counter"><span className="counter-anim">1.8</span>ETH</span>
                      <span className="weight-500 uppercase-font block txt-light">Balance</span>
                    </div>
                    <div className="col-xs-6 text-center  pl-0 pr-0 data-wrap-right">
                      <i className="icon-flag  data-right-rep-icon txt-light" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* /Row */}
    {/* Row */}
    <div className="row">
      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
        <div className="panel card-view">
          <div className="panel-heading small-panel-heading relative">
            <div className="pull-left">
              <h6 className="panel-title">Category Overview</h6>
            </div>
            <div className="clearfix" />
          </div>
          <div className="panel-wrapper collapse in">
            <div className="panel-body row pa-0">
              <div className="sm-data-box">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-xs-6 text-center pl-0 pr-0 data-wrap-left">
                      <span className="block"><i className="zmdi zmdi-trending-up txt-success font-18 mr-5" /><span className="weight-500 uppercase-font">growth</span></span>
                      <span className="txt-dark block counter">$<span className="counter-anim">5,676</span></span>
                    </div>
                    <div className="col-xs-6 text-center  pl-0 pr-0 data-wrap-right">
                      <div id="sparkline_7" className="sp-small-chart"><canvas width={100} height={100} style={{display: 'inline-block', width: 100, height: 100, verticalAlign: 'top'}} /></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="panel card-view bg-gradient2">
          <div className="panel-heading small-panel-heading relative">
            <div className="pull-left">
              <h6 className="panel-title txt-light">Monthly Revenue</h6>
            </div>
            <div className="clearfix" />
          </div>
          <div className="panel-wrapper collapse in">
            <div className="panel-body row pa-0">
              <div className="sm-data-box">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-xs-6 text-center pl-0 pr-0 data-wrap-left txt-light">
                      <span className="block"><i className="zmdi zmdi-trending-up txt-light font-18 mr-5" /><span className="weight-500 uppercase-font">growth</span></span>
                      <span className="block counter">$<span className="counter-anim">15,678</span></span>
                    </div>
                    <div className="col-xs-6 text-center  pl-0 pr-0 data-wrap-right">
                      <div id="sparkline_6" className="sp-small-chart"><canvas width={100} height={124} style={{display: 'inline-block', width: 100, height: 124, verticalAlign: 'top'}} /></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-8 col-md-6 col-sm-12 col-xs-12">
        <div className="panel panel-default card-view panel-refresh">
          <div className="panel-heading">
            <div className="pull-left">
              <h6 className="panel-title txt-dark">Yield graph</h6>
            </div>
          </div>
          <div className="panel-wrapper collapse in">
            <img src={content1} width={620} height={374}/>
          </div>
        </div>
      </div>
    </div>
    {/* /Row */}
    {/* Row */}
    <div className="row">
      <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <div className="panel panel-default card-view">
          <div className="panel-heading">
            <div className="pull-left">
              <h6 className="panel-title txt-dark">Project Sales</h6>
            </div>
            <div className="clearfix" />
          </div>
          <div className="panel-wrapper collapse in">
            <div className="panel-body">
              <div className="table-wrap">
                <div className="table-responsive">
                  <table className="table table-hover mb-0">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Products</th>
                        <th>Popularity</th>
                        <th>Sales</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>Milk Powder</td>
                        <td><span className="peity-bar" data-width={90} data-peity="{ &quot;fill&quot;: [&quot;#635bd6&quot;], &quot;stroke&quot;:[&quot;#635bd6&quot;]}" data-height={40} style={{display: 'none'}}>0,-3,-2,-4,5,-4,3,-2,5,-1</span><svg className="peity" height={40} width={90}><rect fill="#635bd6" x="0.9" y="21.22222222222222" width="7.199999999999999" height={1} /><rect fill="#635bd6" x="9.900000000000002" y="22.22222222222222" width="7.199999999999999" height="13.333333333333336" /><rect fill="#635bd6" x="18.9" y="22.22222222222222" width="7.200000000000003" height="8.88888888888889" /><rect fill="#635bd6" x="27.9" y="22.22222222222222" width="7.200000000000003" height="17.77777777777778" /><rect fill="#635bd6" x="36.89999999999999" y={0} width="7.200000000000017" height="22.22222222222222" /><rect fill="#635bd6" x="45.89999999999999" y="22.22222222222222" width="7.20000000000001" height="17.77777777777778" /><rect fill="#635bd6" x="54.9" y="8.88888888888889" width="7.200000000000003" height="13.333333333333332" /><rect fill="#635bd6" x="63.9" y="22.22222222222222" width="7.199999999999996" height="8.88888888888889" /><rect fill="#635bd6" x="72.9" y={0} width="7.199999999999989" height="22.22222222222222" /><rect fill="#635bd6" x="81.9" y="22.22222222222222" width="7.199999999999989" height="4.444444444444446" /></svg> </td>
                        <td><span className="text-danger text-semibold"><i className="fa fa-level-down" aria-hidden="true" /> 28.76%</span> </td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>Air Conditioner</td>
                        <td><span className="peity-bar" data-width={90} data-peity="{ &quot;fill&quot;: [&quot;#635bd6&quot;], &quot;stroke&quot;:[&quot;#635bd6&quot;]}" data-height={40} style={{display: 'none'}}>0,-1,1,-2,-3,1,-2,-3,1,-2</span><svg className="peity" height={40} width={90}><rect fill="#635bd6" x="0.9" y={9} width="7.199999999999999" height={1} /><rect fill="#635bd6" x="9.900000000000002" y={10} width="7.199999999999999" height={10} /><rect fill="#635bd6" x="18.9" y={0} width="7.200000000000003" height={10} /><rect fill="#635bd6" x="27.9" y={10} width="7.200000000000003" height={20} /><rect fill="#635bd6" x="36.89999999999999" y={10} width="7.200000000000017" height={30} /><rect fill="#635bd6" x="45.89999999999999" y={0} width="7.20000000000001" height={10} /><rect fill="#635bd6" x="54.9" y={10} width="7.200000000000003" height={20} /><rect fill="#635bd6" x="63.9" y={10} width="7.199999999999996" height={30} /><rect fill="#635bd6" x="72.9" y={0} width="7.199999999999989" height={10} /><rect fill="#635bd6" x="81.9" y={10} width="7.199999999999989" height={20} /></svg> </td>
                        <td><span className="text-warning text-semibold"><i className="fa fa-level-down" aria-hidden="true" /> 8.55%</span> </td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>RC Cars</td>
                        <td><span className="peity-bar" data-width={90} data-peity="{ &quot;fill&quot;: [&quot;#635bd6&quot;], &quot;stroke&quot;:[&quot;#635bd6&quot;]}" data-height={40} style={{display: 'none'}}>0,3,6,1,2,4,6,3,2,1</span><svg className="peity" height={40} width={90}><rect fill="#635bd6" x="0.9" y={39} width="7.199999999999999" height={1} /><rect fill="#635bd6" x="9.900000000000002" y={20} width="7.199999999999999" height={20} /><rect fill="#635bd6" x="18.9" y={0} width="7.200000000000003" height={40} /><rect fill="#635bd6" x="27.9" y="33.333333333333336" width="7.200000000000003" height="6.666666666666664" /><rect fill="#635bd6" x="36.89999999999999" y="26.666666666666668" width="7.200000000000017" height="13.333333333333332" /><rect fill="#635bd6" x="45.89999999999999" y="13.333333333333336" width="7.20000000000001" height="26.666666666666664" /><rect fill="#635bd6" x="54.9" y={0} width="7.200000000000003" height={40} /><rect fill="#635bd6" x="63.9" y={20} width="7.199999999999996" height={20} /><rect fill="#635bd6" x="72.9" y="26.666666666666668" width="7.199999999999989" height="13.333333333333332" /><rect fill="#635bd6" x="81.9" y="33.333333333333336" width="7.199999999999989" height="6.666666666666664" /></svg> </td>
                        <td><span className="text-success text-semibold"><i className="fa fa-level-up" aria-hidden="true" /> 58.56%</span> </td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>Down Coat</td>
                        <td><span className="peity-bar" data-width={90} data-peity="{ &quot;fill&quot;: [&quot;#635bd6&quot;], &quot;stroke&quot;:[&quot;#635bd6&quot;]}" data-height={40} style={{display: 'none'}}>0,3,6,4,5,4,7,3,4,2</span><svg className="peity" height={40} width={90}><rect fill="#635bd6" x="0.9" y={39} width="7.199999999999999" height={1} /><rect fill="#635bd6" x="9.900000000000002" y="22.857142857142858" width="7.199999999999999" height="17.142857142857142" /><rect fill="#635bd6" x="18.9" y="5.714285714285715" width="7.200000000000003" height="34.285714285714285" /><rect fill="#635bd6" x="27.9" y="17.142857142857146" width="7.200000000000003" height="22.857142857142854" /><rect fill="#635bd6" x="36.89999999999999" y="11.428571428571427" width="7.200000000000017" height="28.571428571428573" /><rect fill="#635bd6" x="45.89999999999999" y="17.142857142857146" width="7.20000000000001" height="22.857142857142854" /><rect fill="#635bd6" x="54.9" y={0} width="7.200000000000003" height={40} /><rect fill="#635bd6" x="63.9" y="22.857142857142858" width="7.199999999999996" height="17.142857142857142" /><rect fill="#635bd6" x="72.9" y="17.142857142857146" width="7.199999999999989" height="22.857142857142854" /><rect fill="#635bd6" x="81.9" y="28.571428571428573" width="7.199999999999989" height="11.428571428571427" /></svg> </td>
                        <td><span className="text-info text-semibold"><i className="fa fa-level-up" aria-hidden="true" /> 35.76%</span> </td>
                      </tr>
                      <tr>
                        <td>5</td>
                        <td>Xyz Byke</td>
                        <td><span className="peity-bar" data-width={90} data-peity="{ &quot;fill&quot;: [&quot;#635bd6&quot;], &quot;stroke&quot;:[&quot;#635bd6&quot;]}" data-height={40} style={{display: 'none'}}>0,3,6,4,5,4,7,3,4,2</span><svg className="peity" height={40} width={90}><rect fill="#635bd6" x="0.9" y={39} width="7.199999999999999" height={1} /><rect fill="#635bd6" x="9.900000000000002" y="22.857142857142858" width="7.199999999999999" height="17.142857142857142" /><rect fill="#635bd6" x="18.9" y="5.714285714285715" width="7.200000000000003" height="34.285714285714285" /><rect fill="#635bd6" x="27.9" y="17.142857142857146" width="7.200000000000003" height="22.857142857142854" /><rect fill="#635bd6" x="36.89999999999999" y="11.428571428571427" width="7.200000000000017" height="28.571428571428573" /><rect fill="#635bd6" x="45.89999999999999" y="17.142857142857146" width="7.20000000000001" height="22.857142857142854" /><rect fill="#635bd6" x="54.9" y={0} width="7.200000000000003" height={40} /><rect fill="#635bd6" x="63.9" y="22.857142857142858" width="7.199999999999996" height="17.142857142857142" /><rect fill="#635bd6" x="72.9" y="17.142857142857146" width="7.199999999999989" height="22.857142857142854" /><rect fill="#635bd6" x="81.9" y="28.571428571428573" width="7.199999999999989" height="11.428571428571427" /></svg> </td>
                        <td><span className="text-info text-semibold"><i className="fa fa-level-up" aria-hidden="true" /> 35.76%</span> </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <div className="panel panel-default card-view">
          <div className="panel-heading">
            <div className="pull-left">
              <h6 className="panel-title txt-dark">Timelines</h6>
            </div>
            <div className="clearfix" />
          </div>
          <div className="panel-wrapper collapse in">
            <div className="panel-body">
              <div className="streamline user-activity">
                <div className="sl-item">
                  <a href="javascript:void(0)">
                    <div className="sl-avatar avatar avatar-sm avatar-circle">
                      <img className="img-responsive img-circle" src="../img/user.png" alt="avatar" />
                    </div>
                    <div className="sl-content">
                      <p className="inline-block"><span className="capitalize-font txt-primary mr-5 weight-500">Clay Masse</span><span>invited to join the meeting in the conference room at 9.45 am</span></p>
                      <span className="block txt-grey font-12 capitalize-font">3 Min</span>
                    </div>
                  </a>
                </div>
                <div className="sl-item">
                  <a href="javascript:void(0)">
                    <div className="sl-avatar avatar avatar-sm avatar-circle">
                      <img className="img-responsive img-circle" src="../img/user1.png" alt="avatar" />
                    </div>
                    <div className="sl-content">
                      <p className="inline-block"><span className="capitalize-font txt-primary mr-5 weight-500">Evie Ono</span><span>added three new photos in the library</span></p>
                      <div className="activity-thumbnail">
                        <img src="../img/thumb-1.jpg" alt="thumbnail" />
                        <img src="../img/thumb-2.jpg" alt="thumbnail" />
                        <img src="../img/thumb-3.jpg" alt="thumbnail" />
                      </div>
                      <span className="block txt-grey font-12 capitalize-font">8 Min</span>
                    </div>
                  </a>
                </div>
                <div className="sl-item">
                  <a href="javascript:void(0)">
                    <div className="sl-avatar avatar avatar-sm avatar-circle">
                      <img className="img-responsive img-circle" src="../img/user2.png" alt="avatar" />
                    </div>
                    <div className="sl-content">
                      <p className="inline-block"><span className="capitalize-font txt-primary mr-5 weight-500">madalyn rascon</span><span>assigned a new task</span></p>
                      <span className="block txt-grey font-12 capitalize-font">28 Min</span>
                    </div>
                  </a>
                </div>
                <div className="sl-item">
                  <a href="javascript:void(0)">
                    <div className="sl-avatar avatar avatar-sm avatar-circle">
                      <img className="img-responsive img-circle" src="../img/user3.png" alt="avatar" />
                    </div>
                    <div className="sl-content">
                      <p className="inline-block"><span className="capitalize-font txt-primary mr-5 weight-500">Ezequiel Merideth</span><span>completed project wireframes</span></p>
                      <span className="block txt-grey font-12 capitalize-font">yesterday</span>
                    </div>
                  </a>
                </div>
                <div className="sl-item">
                  <a href="javascript:void(0)">
                    <div className="sl-avatar avatar avatar-sm avatar-circle">
                      <img className="img-responsive img-circle" src="../img/user4.png" alt="avatar" />
                    </div>
                    <div className="sl-content">
                      <p className="inline-block"><span className="capitalize-font txt-primary mr-5 weight-500">jonnie metoyer</span><span>created a group 'Hencework' in the discussion forum</span></p>
                      <span className="block txt-grey font-12 capitalize-font">18 feb</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* Row */}
  </div>
)



// WEBPACK FOOTER //
// ./src/pages/DashboardSolo/Overview.tsx